import { render, staticRenderFns } from "./Samples.vue?vue&type=template&id=191c2d85&scoped=true&"
import script from "./Samples.vue?vue&type=script&lang=js&"
export * from "./Samples.vue?vue&type=script&lang=js&"
import style0 from "./Samples.vue?vue&type=style&index=0&id=191c2d85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191c2d85",
  null
  
)

export default component.exports